import { Reducer } from '@reduxjs/toolkit';
import { UserAction } from './user.action';
import { UserActionType, UserState } from './user.types';

const INITIAL_STATE: UserState = {
  auth: null,
};

export const userReducer: Reducer<UserState, UserAction> = (
  state = INITIAL_STATE,
  action,
): UserState => {
  const { type, payload } = action;

  switch (type) {
    case UserActionType.SET_AUTH:
      return {
        ...state,
        auth: payload,
      };

    default:
      return state;
  }
};
